
class WineShowcase {
  constructor(section) {
    this.section = section;
    this.slides = section.querySelectorAll('.slider__slide');
    this.triggers = section.querySelectorAll('[data-slide-trigger]');
    this.currentIndex = 0;

    this.autoplay = section.dataset.autoplay === 'true';
    this.speed = parseInt(section.dataset.speed, 10) || 3000;
    this.timer = null;

    if (!this.slides.length || !this.triggers.length) return;

    this.init();
  }

  init() {
    this.bindEvents();
    this.setActive(0);
    this.startAutoplay();
  }

  // bindEvents() {
  //   this.triggers.forEach((trigger, index) => {
  //     trigger.addEventListener('click', () => {
  //       this.setActive(index);
  //       this.startAutoplay();
  //     });
  //   });

  //   this.section.addEventListener('mouseenter', () => this.stopAutoplay());
  //   this.section.addEventListener('mouseleave', () => this.startAutoplay());
  // }
  //bindEvents() {
    // this.section.addEventListener('mouseenter', () => this.stopAutoplay());
    // this.section.addEventListener('mouseleave', () => this.startAutoplay());
  //}
    bindEvents() {
    this.triggers.forEach((trigger, index) => {
        trigger.addEventListener('mouseenter', () => {
        this.setActive(index);
        this.startAutoplay();
        });
    });

    this.section.addEventListener('mouseenter', () => this.stopAutoplay());
    this.section.addEventListener('mouseleave', () => this.startAutoplay());
    }
  setActive(index) {
    this.currentIndex = index;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });

    this.triggers.forEach((trigger, i) => {
      const active = i === index;
      trigger.classList.toggle('is-active', active);
      trigger.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  next() {
    const next = (this.currentIndex + 1) % this.slides.length;
    this.setActive(next);
  }

  startAutoplay() {
    if (!this.autoplay || this.slides.length < 2) return;
    this.stopAutoplay();
    this.timer = setInterval(() => this.next(), this.speed);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}

// Shopify section load support
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-wine-showcase]').forEach(section => {
    new WineShowcase(section);
  });
});

document.addEventListener('shopify:section:load', (e) => {
  const section = e.target.querySelector('[data-wine-showcase]');
  if (section) new WineShowcase(section);
});